import OvertimeReportEditConfigController from './OvertimeReportEditConfigController'
import {Feature, isEnabled} from '../../../features'
import {ReportGroupingLevel} from '../../constants'

export default class OvertimeEditFormConfigController extends OvertimeReportEditConfigController {}

OvertimeEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function ( reportParameters ) {
    const result = {...reportParameters};
    let groupings = null;
    if (!isEnabled(Feature.UGR))
    {
        groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(ReportGroupingLevel.USER_GROUP,
            [result.firstGroupingLevel, result.secondGroupingLevel],
            ReportGroupingLevel.USER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }
    if (!isEnabled(Feature.TZG))
    {
        groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(ReportGroupingLevel.TIME_ZONE_GROUP,
            [result.firstGroupingLevel, result.secondGroupingLevel],
            ReportGroupingLevel.USER);
        result.firstGroupingLevel = groupings[0];
        result.secondGroupingLevel = groupings[1];
    }
    return result;
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/overtime/OvertimeEditFormConfigController.js